import instance from '@apis/instance';

const CACHE_ENDPOINT = '/cache';

const fetchRefreshToken = (userId: string) =>
  instance.get(CACHE_ENDPOINT, {
    params: { userId },
    headers: { notInterceptor: true },
  });

const storeRefreshToken = ({
  userId,
  refreshToken,
}: {
  userId: string;
  refreshToken: string;
}) =>
  instance.post(
    CACHE_ENDPOINT,
    { userId, refreshToken },
    { headers: { notInterceptor: true } },
  );

export default {
  fetchRefreshToken,
  storeRefreshToken,
};
